// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__tCZzM","label":"LabeledBox_label__18RAi"};